<div>
    <div class="year-title-banner" nz-row>
        <div class="box-art-image" nz-col nzSpan="24">
            <img src="../../../../../assets/images/svgs/box-art.svg" />
            <span class="year">
                2022
            </span>
        </div>
        <div class="desc" nz-col nz-col nzSpan="24">
            YEAR IN REVIEW
        </div>
        <div class="stars-icon">
            <svg width="69" height="18" viewBox="0 0 69 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M4.63445e-05 9.39865C1.63696e-05 9.40572 0 9.41279 0 9.41987C0 9.42535 9.38645e-06 9.43082 2.7332e-05 9.4363C2.59481 9.6601 4.66214 11.7287 4.88395 14.3241C4.89071 14.3241 4.89748 14.3241 4.90425 14.3241C4.91061 14.3241 4.91698 14.3241 4.92334 14.3241C5.14517 11.7283 7.21311 9.65946 9.80847 9.43619C9.80849 9.43076 9.8085 9.42532 9.8085 9.41987C9.8085 9.41283 9.80848 9.40579 9.80845 9.39875C7.21471 9.17561 5.14773 7.10917 4.92375 4.51566C4.91725 4.51564 4.91075 4.51562 4.90425 4.51562C4.89734 4.51562 4.89044 4.51564 4.88354 4.51567C4.65959 7.10877 2.59322 9.17497 4.63445e-05 9.39865Z"
                    fill="#FED75B" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M25.502 9.37963C25.502 9.39254 25.502 9.40545 25.502 9.41837C25.502 9.42849 25.502 9.4386 25.502 9.44871C30.0428 9.83987 33.6608 13.4593 34.0497 18.0007C34.0613 18.0008 34.0728 18.0008 34.0844 18.0008C34.0959 18.0008 34.1073 18.0008 34.1188 18.0007C34.5077 13.4592 38.1259 9.83974 42.6668 9.44869C42.6668 9.43859 42.6668 9.42848 42.6668 9.41837C42.6668 9.40549 42.6668 9.39261 42.6667 9.37973C38.1286 8.98892 34.5121 5.37361 34.1195 0.836008C34.1078 0.835961 34.0961 0.835938 34.0844 0.835938C34.0726 0.835938 34.0608 0.835961 34.0491 0.836009C33.6564 5.3735 30.04 8.98872 25.502 9.37963Z"
                    fill="#FED75B" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M58.3604 9.3986C58.3604 9.40568 58.3604 9.41278 58.3604 9.41987C58.3604 9.42537 58.3604 9.43086 58.3604 9.43635C60.9549 9.66041 63.0219 11.7289 63.2437 14.3241C63.2507 14.3241 63.2576 14.3241 63.2646 14.3241C63.2708 14.3241 63.2769 14.3241 63.2831 14.3241C63.505 11.7281 65.5732 9.65915 68.1688 9.43614C68.1688 9.43072 68.1688 9.4253 68.1688 9.41987C68.1688 9.41284 68.1688 9.40582 68.1688 9.3988C65.5748 9.17592 63.5075 7.10936 63.2835 4.51566C63.2772 4.51564 63.2709 4.51562 63.2646 4.51562C63.2575 4.51562 63.2504 4.51564 63.2433 4.51567C63.0194 7.10858 60.9533 9.17466 58.3604 9.3986Z"
                    fill="#FED75B" />
            </svg>
        </div>
    </div>
    <ng-container *ngIf="loading">
        <app-loading [loadingText]="'loading'|translate"></app-loading>
    </ng-container>
    <ng-container *ngIf="errorMessage">
        <app-custom-error-display [errorMessage]="errorMessage"></app-custom-error-display>
    </ng-container>
    <ng-container *ngIf="!loading && endOfYearSummary">
        <div nz-row class="bu-detail">
            <div class="name" nz-col nzSpan="24">
                Hey <span class="text-bolder">{{endOfYearSummary?.businessName}},</span>
            </div>
            <div class="desc" nz-col nzSpan="24">
                Your business grew this year and we’re proud to have been part of it.
                <br>
                Here is the summary of progress you made:
            </div>
        </div>
        <div nz-row class="progress">
            <div class="card-payment progress-card">
                <div nz-row>
                    <span class="card-icon">
                        <app-grey-icon [greyIcon]="'grey-card'"></app-grey-icon>
                    </span>
                    <span class="m-l-5 text-label">
                        Card Payment
                    </span>
                </div>
                <div nz-row class="card-amount">
                    <div class="amount">
                        {{endOfYearSummary?.totalCardPaymentVolume | amountUnit}}
                    </div>
                    <div class="desc">
                        Customers paid with their cards
                    </div>
                </div>
            </div>
            <div class="deposit progress-card">
                <div nz-row>
                    <span class="deposit-icon">
                        <app-grey-icon [greyIcon]="'grey-account'"></app-grey-icon>
                    </span>
                    <span class="m-l-5 text-label">
                        Transfer
                    </span>
                </div>
                <div nz-row class="deposit-amount">
                    <div class="amount">
                        {{endOfYearSummary?.totalDepositVolume | amountUnit}}
                    </div>
                    <div class="desc">
                        Customers made transfers
                    </div>
                </div>
            </div>
        </div>
        <div nz-row class="transactions">
            <div class="desc">
                In these months, you had the highest and lowest transactions:
            </div>
            <div class="highest-transaction transaction-card">
                <div nz-row>
                    <span class="up-arrow-icon">
                        <app-icon [icon]="'circle-up-arrow'"></app-icon>
                    </span>
                    <span class="m-l-10 text-label">
                        Highest
                    </span>
                </div>
                <div nz-row class="transaction-amount">
                    <div class="amount" nz-col nzSpan="14">
                        {{endOfYearSummary?.highestMonthVolume | amountUnit}}
                    </div>
                    <div class="description" nz-col nzSpan="10">
                        Transactions in the
                        <br>
                        month of
                        <br>
                        <span class="month">{{!endOfYearSummary?.monthWithHighestVolume ? 'N/A' :
                            endOfYearSummary?.monthWithHighestVolume}}</span>
                    </div>
                </div>
            </div>
            <div class="lowest-transaction transaction-card">
                <div nz-row>
                    <span class="down-arrow-icon">
                        <app-icon [icon]="'circle-down-arrow'"></app-icon>
                    </span>
                    <span class="m-l-10 text-label">
                        Lowest
                    </span>
                </div>
                <div nz-row class="transaction-amount">
                    <div class="amount" nz-col nzSpan="14">
                        {{endOfYearSummary?.lowestMonthVolume | amountUnit}}
                    </div>
                    <div class="description" nz-col nzSpan="10">
                        Transactions in the
                        <br>
                        month of
                        <br>
                        <span class="month">{{!endOfYearSummary?.monthWithLowestVolume ? 'N/A' :
                            endOfYearSummary?.monthWithLowestVolume}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div nz-row class="transaction-summary">
            <div class="desc">
                In all, 2022 was a great year for you as you did:
            </div>
            <div class="summary-card">
                <div nz-row class="main-section">
                    <div nz-row>
                        <span class="summary-icon">
                            <app-grey-icon [greyIcon]="'grey-transfer-deposit'"></app-grey-icon>
                        </span>
                        <span class="m-l-10 text-label">
                            Transaction Summary
                        </span>
                    </div>

                    <div nz-col nzSpan="24" class="summary-amount">
                        <div class="amount" nz-col nzSpan="24">
                            ₦{{endOfYearSummary?.totalCardAndDepositValue | amountUnit}}
                        </div>
                        <div class="description" nz-col nzSpan="24">
                            in Total transactions
                        </div>
                    </div>
                </div>
                <div nz-row class="payments">
                    <div nz-col nzSpan="12" class="card-payments">
                        <div class="title">
                            Card Payments
                        </div>
                        <div class="amount">
                            ₦{{endOfYearSummary?.totalCardPaymentValue | amountUnit}}
                        </div>
                    </div>
                    <div nz-col nzSpan="12" class="desposit-payments">
                        <div class="title">
                            Transfers
                        </div>
                        <div class="amount">
                            ₦{{endOfYearSummary?.totalDepositValue | amountUnit : 2}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div nz-row class="greetings m-t-36">
            What a year! Thank you for choosing <br>
            <span class="monie-point-text">Moniepoint</span> and we look forward to riding with <br>
            you again in <span class="year">2023</span>.
        </div>
        <div nz-row class="monie-point-logo">
            <img alt="logo" src="../../../../../assets/images/new-moniepoint-logo.svg" class="moniepoint-main-logo">
        </div>
        <div nz-row class="bottom-section">
            <div class="bottom-svg">
                <img src="../../../../../assets/images/svgs/yearly-report-bottom.svg">
            </div>
        </div>
    </ng-container>

</div>